module.exports = __webpack_public_path__ + "static/media/photo193.fed7639f.jpg";